import React from 'react';

import '@awesome.me/webawesome/dist/components/animation/animation.js';

const Loading: React.FC = () => {
  return (
    <div className="loading-container">
      <wa-animation name="bounce" easing="ease-in-out" duration={1000} play>
        <img src="/images/lgcy-loading.png" alt="Loading..." className="loading-spinner" />
      </wa-animation>
    </div>
  );
}

export default Loading;
